import { UncontrolledTooltip } from "reactstrap";

export default function TruncateTd({ content, children, _key, className }) {
    return (
        <td className={className} id={_key} key={_key}>
            {children}
            {content &&
                <UncontrolledTooltip placement="right" target={_key}>
                    {content || ''}
                </UncontrolledTooltip>
            }
        </td>
    )
}